/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { swalMessages, permitsList } from 'src/constants'
import AdminControl from 'src/pages/AdminControl/UsersAdmin/AdminControl'
import administratorService from 'src/services/administratorService'
import { Context } from 'src/context/Contex'
import * as paths from 'src/routes/paths'
import { loaderService } from 'src/services/loaderService'

const AdminContainer = () => {
  const [users, setUsers] = useState([])
  const [usersBlocked, setUsersBlocked] = useState([])
  const [loading, setLoading] = useState(false)
  const { permisos, setUserId } = useContext(Context)
  const dataTable = []
  const dataTableBlocked = []

  const history = useHistory()

  /*= =======================================================================
  Get Users
======================================================================== */

  const getUsers = () => {
    setLoading(true)
    loaderService.show()
    administratorService
      .getUsers()
      .then((response) => {
        response.data.data.forEach((user) => {
          dataTable.push({
            name: user.nombre,
            apellido: user.apellido,
            mail: user.correo,
            id: user.id,
            idCreation: 0,
          })
        })
        setUsers(response.data.data)
        loaderService.hide()
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const getUsersBlocked = () => {
    setLoading(true)
    loaderService.show()
    administratorService
      .getUsersBlocked()
      .then((response) => {
        response.data.data.forEach((user) => {
          dataTableBlocked.push({
            name: user.nombre,
            apellido: user.apellido,
            mail: user.correo,
            id: user.id,
            idCreation: 0,
          })
        })
        setUsersBlocked(response.data.data)
        loaderService.hide()
      })
      .catch((error) => {
        console.log(error)
      })
  }
  useEffect(() => {
    getUsers()
    getUsersBlocked()
  }, [])

  const handleDelete = ({ event, rowData }) => {
    event.preventDefault()
    swal(swalMessages.DELETE_CONFIRM).then((willDelete) => {
      if (willDelete) {
        administratorService
          .deleteUser(rowData.id)
          .then((response) => {
            if (response.data.id === 0) {
              swal(swalMessages.GENERAL_ERROR)
            }
            getUsers()
          })
          .catch((error) => {
            console.log(error)
          })
      }
    })
  }

  const handleUnlock = ({ event, rowData }) => {
    event.preventDefault()
    swal(swalMessages.UNLOCK_CONFIRM).then((willDelete) => {
      if (willDelete) {
        administratorService
          .unlockUser({correo: rowData.mail})
          .then((response) => {
            if (response.data.id === 0) {
              swal(swalMessages.GENERAL_ERROR)
            }
            getUsers()
            getUsersBlocked()
          })
          .catch((error) => {
            console.log(error)
          })
      }
    })
  }

  const handleEdit = ({ event, rowData }) => {
    event.preventDefault()
    setUserId(rowData)
    history.push(paths.ADMIN_USERS_PERMITS)
  }

  const handleClick = (event) => {
    event.preventDefault()
    history.push(paths.ADMIN_USERS_CREATOR)
  }

  const columns = [
    { title: 'Nombre', field: 'name' },
    { title: 'Apellido', field: 'apellido' },
    { title: 'Correo', field: 'mail' },
    { title: 'id', field: 'id', hidden: true },
  ]

  if (users) {
    try {
      users.forEach((user) => {
        dataTable.push({
          name: user.nombre,
          apellido: user.apellido,
          mail: user.correo,
          id: user.id,
          idCreation: 0,
        })
      })
    } catch (err) {}
  }

  if (usersBlocked) {
    try {
      usersBlocked.forEach((userBlocked) => {
        dataTableBlocked.push({
          name: userBlocked.nombre,
          apellido: userBlocked.apellido,
          mail: userBlocked.correo,
          id: userBlocked.id,
          idCreation: 0,
        })
      })
    } catch (err) {}
  }
  const minValue = permisos[permitsList.ADMIN_USUARIOS]

  return (
    <>
      <AdminControl
        minValue={minValue}
        users={dataTable}
        usersBlocked={dataTableBlocked}
        permisos={permisos}
        columns={columns}
        loading={loading}
        handleEdit={handleEdit}
        handleClick={handleClick}
        handleDelete={handleDelete}
        handleUnlock={handleUnlock}
      />
    </>
  )
}

export default AdminContainer
